import { checkDomainAvailability as publicCheckDomainAvailability } from './premium-domains-v2-availability-domain-availability.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const checkDomainAvailability: MaybeContext<
  BuildRESTFunction<typeof publicCheckDomainAvailability> &
    typeof publicCheckDomainAvailability
> = /*#__PURE__*/ createRESTModule(publicCheckDomainAvailability);

export { PremiumType } from './premium-domains-v2-availability-domain-availability.universal.js';
export {
  DomainAvailability,
  CheckDomainAvailabilityRequest,
  CheckDomainAvailabilityResponse,
} from './premium-domains-v2-availability-domain-availability.universal.js';
export { PremiumTypeWithLiterals } from './premium-domains-v2-availability-domain-availability.universal.js';
